export const EMPTY_MEDIAS_PATH = '/images/empty-medias.svg';
export const EMPTY_CHAT_PATH = '/images/chat.svg';
export const EMPTY_STOCK_PATH = '/images/empty-stock.svg';
export const TECEO_LOGIN_BACKGROUND_PATH = '/images/teceo-patterns.png';
export const EMPTY_CHART = '/images/charts.svg';
export const SERVER_ERROR = '/images/server-error.svg';
export const FILE_ICON = '/images/file-icon.svg';
export const TECEO_SIMBOL_GRAPHITE = '/teceo-simbol-graphite.svg';
export const TECEO_TEXT_LOGO_WITH_ORANGE = '/images/teceo-text-logo-with-orange.svg';
export const EMPTY_IMAGE = '/images/empty-image.png';
